import styles from './styles.module.scss';

const ToggleWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => <div className={styles['toggle-wrapper']}>{children}</div>;

export default ToggleWrapper;
